module.exports = __webpack_public_path__ + "static/img/kegs-preloader.291fc89.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kegs-preloader.gif
// module id = NmLr
// module chunks = 1